import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import crmApi from '../../utils/crmApi';
import useLiveRefresh from '../../utils/useLiveRefresh';

export default function CrmCategories() {
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', description: '', code: '', category_type: 'other' });
  const [err, setErr] = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);

  function load(silent) { if (!silent) setLoading(true); crmApi.get('/categories').then(setCats).finally(() => { if (!silent) setLoading(false); }); }
  useEffect(() => { load(); }, []);
  useLiveRefresh(() => load(true));

  async function openNew() {
    setEditing(null);
    setForm({ name: '', description: '', code: '', category_type: 'other' });
    setShow(true);
    try { const r = await crmApi.get('/next-code/category'); setForm(f => ({ ...f, code: r.code })); } catch (e) { /* ignore */ }
  }
  function openEdit(c) { setEditing(c.id); setForm({ name: c.name, description: c.description || '', code: c.code || '', category_type: c.category_type || 'other' }); setShow(true); }
  async function save() {
    if (!form.name.trim()) return;
    if (editing) await crmApi.put(`/categories/${editing}`, form);
    else await crmApi.post('/categories', form);
    setShow(false); load();
  }
  async function doDelete() {
    if (!confirmDel) return;
    try { await crmApi.delete(`/categories/${confirmDel.id}`); setConfirmDel(null); load(); }
    catch (e) { setConfirmDel(null); setErr(e?.error || 'Failed'); setTimeout(() => setErr(null), 5000); }
  }


  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
        <div>
          <h1 style={{ fontSize: '20px', fontWeight: '800' }}>Categories</h1>
          <p style={{ fontSize: '13px', color: 'var(--muted)' }}>Group your products — e.g. Bandwidth, Starlink, VSAT equipment.</p>
        </div>
        <button className="btn btn-primary" style={{ marginLeft: 'auto' }} onClick={openNew}>+ New Category</button>
      </div>

      {err && <div style={{ background: 'rgba(220,38,38,0.1)', color: '#DC2626', padding: '10px 14px', borderRadius: 'var(--radius)', fontSize: '13px', marginBottom: '12px' }}>{err}</div>}

      <div className="card" style={{ overflow: 'hidden' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '130px 1.5fr 2fr 100px 120px', background: 'var(--surface2)', borderBottom: '1px solid var(--border)' }}>
          {['Code', 'Name', 'Description', 'Products', 'Actions'].map(h => (
            <div key={h} style={{ padding: '10px 16px', fontSize: '11px', fontWeight: '700', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.6px' }}>{h}</div>
          ))}
        </div>
        {loading ? <div style={{ padding: '20px', color: 'var(--muted)' }}>Loading…</div> :
          cats.length === 0 ? <div style={{ padding: '24px', textAlign: 'center', color: 'var(--muted)', fontSize: '13px' }}>No categories yet.</div> :
            cats.map((c, i) => (
              <div key={c.id} style={{ display: 'grid', gridTemplateColumns: '130px 1.5fr 2fr 100px 120px', borderBottom: i < cats.length - 1 ? '1px solid var(--border)' : 'none', alignItems: 'center' }}>
                <div style={{ padding: '12px 16px', fontSize: '12px', fontWeight: '700', fontFamily: 'var(--font-mono)', color: '#0D9488' }}>{c.code || '—'}</div>
                <div style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '700' }}>{c.name}</div>
                <div style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--muted2)' }}>{c.description || '—'}</div>
                <div style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '700' }}>{c.product_count}</div>
                <div style={{ padding: '12px 16px', display: 'flex', gap: '6px' }}>
                  <button className="btn btn-sm" onClick={() => openEdit(c)}>Edit</button>
                  <button className="btn btn-sm" onClick={() => setConfirmDel(c)} style={{ color: '#DC2626' }}>Delete</button>
                </div>
              </div>
            ))}
      </div>

      {show && (
        <div className="modal-overlay" onClick={e => { if (e.target === e.currentTarget) setShow(false); }}>
          <div className="modal" style={{ width: '420px' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '800', marginBottom: '16px' }}>{editing ? 'Edit Category' : 'New Category'}</h3>
            <div className="form-group"><label className="form-label">Name *</label><input className="input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></div>
            <div className="form-group"><label className="form-label">Stock Code <span style={{ color: 'var(--muted)', fontWeight: 400, fontSize: 10 }}>(auto — you can change it)</span></label><input className="input" style={{ fontFamily: 'var(--font-mono)' }} value={form.code} onChange={e => setForm({ ...form, code: e.target.value })} placeholder="SCT-CAT-0001" /></div>
            <div className="form-group"><label className="form-label">Category Type <span style={{ color: 'var(--muted)', fontWeight: 400, fontSize: 10 }}>(controls inventory behaviour)</span></label>
              <select className="select" value={form.category_type} onChange={e => setForm({ ...form, category_type: e.target.value })}>
                <option value="hardware">Hardware (needs inventory approval, reduces stock)</option>
                <option value="capacity">Capacity</option>
                <option value="lease">Lease</option>
                <option value="service">Service</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="form-group"><label className="form-label">Description</label><input className="input" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} /></div>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button className="btn" onClick={() => setShow(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={save}>{editing ? 'Save' : 'Create'}</button>
            </div>
          </div>
        </div>
      )}
      {confirmDel && (
        <div className="modal-overlay" onClick={e => { if (e.target === e.currentTarget) setConfirmDel(null); }}>
          <div className="modal" style={{ width: '380px' }}>
            <h3 style={{ fontSize: '15px', fontWeight: '800', marginBottom: '8px' }}>Delete category?</h3>
            <p style={{ fontSize: '13px', color: 'var(--muted2)', lineHeight: 1.6, marginBottom: '14px' }}><strong>{confirmDel.name}</strong> will be removed. Products already using it keep their category reference.</p>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button className="btn" onClick={() => setConfirmDel(null)}>Cancel</button>
              <button className="btn" style={{ background: '#DC2626', color: '#fff', borderColor: '#DC2626' }} onClick={doDelete}>Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
